import React from 'react';

const Footer = () => {
    return (
        <footer>
            <div className="row bg-dark">
                <div className="col-12">
                    <p className="text-center text-warning"><small> @ Abdul Basir all right reserve 2020</small></p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;